
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs/internal/Observable';
//import { CONFIG } from '../config';

import { JwtHelperService } from "@auth0/angular-jwt";
import { LoginPage } from '../../pages/login/login';
import {UserData} from '../user-data';
// import { StorageService } from "../storage-service";
import {HandleRequest} from '../handleRequest';
import {AuthService} from 'ng2-ui-auth';
//import { Page1 } from '../pages/page1/page1'; //TODO

declare var CONFIG:any;
@Injectable()
export class AuthTokenStatus {
  jwtHelper: JwtHelperService = new JwtHelperService();
  auth_status:boolean;
  constructor(private auth: AuthService,private http: HttpClient, private sharedData:UserData, private handleRequest:HandleRequest/*,private storage: StorageService,*/) {
  }

  tokenStatus(gotoPage:any =""){
    console.warn("this.auth_status", this.auth_status)
    return this.auth_status;
  }
  logout(){
    this.auth_status = false;
  }
  load(){
    let url=window.location.href;
      console.log("url",url)
      if(url.indexOf('/app/')>-1){
        return new Promise((resolve, reject) => {resolve(true);})
      }
      
    console.log("AuthTokenStatus load", localStorage.getItem('voipboxIonAppToken'))
    var jwt = localStorage.getItem('voipboxIonAppToken');
    // var authHeader = new Headers();
    // let content = new URLSearchParams();
    // if(jwt) {
    //   authHeader.append('Content-Type', 'application/x-www-form-urlencoded');
    //   content.set('token', jwt);
    // }
    return new Promise((resolve, reject) => {
      console.log("tttttttttttttttttt1111", window.location)
      if(window.location.href.indexOf("/login")>-1) {
        console.log("tttttttttttttttttt222222", window.location)
        resolve(true);
      }else if(window.location.href.indexOf("/app/room/")>-1) {
        
        jwt = window.location.href
        console.log("ttttttttttttttttt333333", window.location,jwt)
        this.handleRequest.post('/api/user_token_status?token='+jwt,
                      {token:jwt})
      
      .subscribe(res => {
                  console.log("tttttt load--------------success-token status");
                  this.auth_status = true;
                  resolve(true);
                  },
                  err => {
                    // //console.log("load-----------------error-token status", err);
                    // //this.navCtrl.setRoot(LoginPage)
                    this.auth_status = false;

                    console.log("tttttttttttttttttt", window.location)
                    // if(window.location.href.indexOf("/login")==-1) {
                      window.location.href = 'https://acvideo.voipappz.io/api/error';//TODO
                    // }
                    resolve(true);
                  }
                );
      }else if(jwt){
        console.log("tttttttttttttttttt4444", window.location)
        this.handleRequest.post('/api/token_status?token='+jwt,
                      {token:jwt})
      
      .subscribe(res => {
                  console.log("tttttt load--------------success-token status");
                  this.auth_status = true;
                  resolve(true);
                  },
                  err => {
                    // //console.log("load-----------------error-token status", err);
                    // //this.navCtrl.setRoot(LoginPage)
                    this.auth_status = false;

                    console.log("tttttttttttttttttt", window.location)
                    if(window.location.href.indexOf("/login")==-1) {
                      window.location.href = '/#/login';
                    }
                    resolve(true);
                  }
                );
      }else{
        resolve(true)
      }
    });
    // this.loadCustomerData();

    // var jwt = localStorage.getItem('voipboxIonAppToken');
    // var authHeader = new Headers();
    // let content = new URLSearchParams();
    // if(jwt) {
    //   authHeader.append('Content-Type', 'application/x-www-form-urlencoded');
    //   content.set('token', jwt);
    // }
    // return new Promise((resolve, reject) => {
    //   console.log("tttttttttttttttttt1111", window.location)
    //   if(window.location.href.indexOf("/login/")>-1) {
    //     resolve(true);
    //   }else{
    //     this.http.post(CONFIG.API_ENDPOINT + '/auth/user_token_status?'+content.toString(),
    //                   content.toString(),
    //                   {headers: authHeader})
    //   .catch(error => {
    //     console.log("tttttttttttttttttt", window.location)
    //     if(window.location.href.indexOf("/login/")==-1) {
    //       window.location.href = '/#/login';
    //     }
    //     return Observable.throw(error);
    //   })
    //   .subscribe(res => {
    //               console.log("tttttt load--------------success-token status");
    //                this.loadUserData(jwt)
    //                .map(res => res.json())
    //                .subscribe(res=> {
    //                    this.sharedData.setUserData(res);
    //                    this.auth_status=true;
    //                    resolve(true);
    //                    console.log("load--------------success-token status", this.auth_status);
    //                  },
    //                  (err)=>{
    //                    this.auth_status = false;/*this.navCtrl.setRoot(LoginPage);*/
    //                    resolve(true);
    //                })
    //               },
    //               err => {
    //                 //console.log("load-----------------error-token status", err);
    //                 //this.navCtrl.setRoot(LoginPage)
    //                 this.auth_status = false;
    //                 resolve(true);
    //               }
    //             );
    //   }
    // });

  }
  private loadCustomerData(){
    // let storage_data;
    //  this.storage.getData("voipboxAppCustomerData")
    //  .then(data => {
    //    storage_data = data;
    //    if(!storage_data || !storage_data.url){//TODO add condition to validate data
    //      this.handleRequest.getCustomerData()
    //      .map(res => res.json())
    //      .subscribe(res=> {
    //        console.log("-------------------loadCustomerData", res);
    //        res.url = (res.url)? res.url : "https://admin-staging.voipappz.io/assets/admin/layout4/img/VA_logo_white.png"
    //        res.url_login = (res.url_login)? res.url_login : "assets/img/VA_logo_white.png"
    //          this.storage.setData('voipboxAppCustomerData', res);
    //          this.sharedData.setCustomerData(res)
    //        },
    //        (err)=>{
    //          //TODO use default data?
    //          console.error("ERR-------------------loadCustomerData", err);
    //          let d:any = {}
    //          d.url =  "https://admin-staging.voipappz.io/assets/admin/layout4/img/VA_logo_white.png"
    //          d.url_login = "assets/img/VA_logo_white.png"
    //          this.sharedData.setCustomerData(d)
    //      })
    //    }else{
    //      this.sharedData.setCustomerData(storage_data)
    //    }
    //    console.log("loadCustomerData", storage_data);
    //  })
    //  .catch(error => {
    //    console.error(error);
    //  });


  }
  private loadUserData(token){
    //   console.log(
    //   this.jwtHelper.decodeToken(token),
    //   this.jwtHelper.getTokenExpirationDate(token),
    //   this.jwtHelper.isTokenExpired(token)
    // );
    var authHeader = new HttpHeaders();
    authHeader.append('Authorization', 'Basic ' + token);
    authHeader.append('X-VA-Auth', "user")
    let dataUrl = {headers: authHeader}
    return this.http.get(CONFIG.API_ENDPOINT + '/api/users/'+this.jwtHelper.decodeToken(token).user_uuid, dataUrl)
  }

}
